// extracted by mini-css-extract-plugin
module.exports = {"buildId":"BuildId-module--buildId--kCvkn"};